export type SunmiPrinterStatus = {
    name: string
    code: number
}

export type SunmiPrinterInfo = {
    name: string | null
    type: string | null
    paper: string | null
}

export type SunmiPrinterModuleType = {
    /**
     * @returns The default printer metadata, or `null` when none is available.
     * @throws {import('expo-modules-core').CodedError} When printer discovery or metadata querying
     * fails.
     */
    getDefaultPrinterInfo: () => Promise<SunmiPrinterInfo | null>

    /**
     * @returns The default printer status, or `null` when none is available.
     * @throws {import('expo-modules-core').CodedError} When printer discovery or status querying
     * fails.
     */
    getDefaultPrinterStatus: () => Promise<SunmiPrinterStatus | null>

    /**
     * Sends ESC/POS commands to the default printer.
     *
     * @param base64Data Base64-encoded ESC/POS command bytes.
     * @throws {import('expo-modules-core').CodedError} When the payload is invalid, no default
     * printer is available, or printer discovery or submission fails.
     */
    sendEscPosCommands: (base64Data: string) => Promise<void>
}
